(function () {
  if (customElements.get('fab-quick-add-modal')) return;

  var SECTION_ID = 'fab-quick-add';
  var depsPromise = null;

  function loadQuickAddDeps() {
    if (depsPromise) return depsPromise;
    var cfgEl = document.querySelector('[data-fab-quick-add-assets]');
    var cfg = { css: [], js: [] };
    try { cfg = JSON.parse((cfgEl && cfgEl.textContent) || '{}') || cfg; } catch (e) {}

    function appendStylesheet(href) {
      if (!href || document.querySelector('link[href="' + href + '"]')) return Promise.resolve();
      return new Promise(function (resolve, reject) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.onload = resolve;
        link.onerror = function () { reject(new Error('Quick-add stylesheet failed')); };
        document.head.appendChild(link);
      });
    }

    function appendScript(src) {
      if (!src || document.querySelector('script[src="' + src + '"]')) return Promise.resolve();
      return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = function () { reject(new Error('Quick-add script failed')); };
        document.head.appendChild(script);
      });
    }

    depsPromise = Promise.all((cfg.css || []).map(appendStylesheet))
      .then(function () {
        return (cfg.js || []).reduce(function (promise, src) {
          return promise.then(function () {
            return appendScript(src);
          });
        }, Promise.resolve());
      })
      .catch(function (error) {
        depsPromise = null;
        throw error;
      });
    return depsPromise;
  }

  function isModifiedClick(event) {
    return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
  }

  function productUrlFromHref(href, extraParam, extraValue) {
    try {
      var url = new URL(href, window.location.origin);
      if (url.pathname.indexOf('/products/') === -1) return '';
      if (extraParam) url.searchParams.set(extraParam, extraValue);
      url.hash = '';
      return url.pathname + '?' + url.searchParams.toString();
    } catch (error) {
      return '';
    }
  }

  function fetchProductHtml(href, signal) {
    var urls = [
      productUrlFromHref(href, 'section_id', SECTION_ID),
      productUrlFromHref(href, 'view', 'quick-add'),
    ].filter(Boolean);

    function next(index) {
      if (index >= urls.length) return Promise.reject(new Error('quick-add missing product-info'));
      return fetch(urls[index], { credentials: 'same-origin', signal: signal }).then(function (response) {
        if (!response.ok) return next(index + 1);
        return response.text().then(function (text) {
          var html = new DOMParser().parseFromString(text, 'text/html');
          if (html.querySelector('product-info')) return text;
          return next(index + 1);
        });
      });
    }

    return next(0);
  }

  function setInnerHTML(element, html) {
    if (window.HTMLUpdateUtility && typeof HTMLUpdateUtility.setInnerHTML === 'function') {
      HTMLUpdateUtility.setInnerHTML(element, html);
      return;
    }
    element.innerHTML = html;
  }

  class FabQuickAddModal extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('[data-fab-quick-add-content]');
      this.status = this.querySelector('[data-fab-quick-add-status]');
      this.dialog = this.querySelector('[role="dialog"]');
      this.abortController = null;
      this.openedBy = null;
      this.requestId = 0;
      this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
      this.addEventListener('keyup', function (event) {
        if (event.code && event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
      this.addEventListener('click', function (event) {
        if (event.target === this) this.hide();
      });
      this.addEventListener('change', this.syncSelectedVariant.bind(this));
      this.addEventListener('submit', this.syncSelectedVariant.bind(this), true);
    }

    syncSelectedVariant(event) {
      var target = event && event.target;
      var productInfo = target && target.closest ? target.closest('product-info') : null;
      if (!productInfo) productInfo = this.content && this.content.querySelector('product-info');
      if (!productInfo) return;

      var variantSelects = productInfo.querySelector('variant-selects');
      if (!variantSelects) return;

      var controls = Array.prototype.slice.call(
        variantSelects.querySelectorAll(
          'select[data-option-position], input[type="radio"][data-option-position]:checked'
        )
      );
      controls.sort(function (a, b) {
        return Number(a.getAttribute('data-option-position')) - Number(b.getAttribute('data-option-position'));
      });
      var selectedOptions = controls.map(function (control) { return control.value; });
      if (!selectedOptions.length) return;

      var variants = [];
      try {
        variants = JSON.parse(variantSelects.getAttribute('data-variants') || '[]');
      } catch (error) {
        return;
      }
      var variant = variants.find(function (candidate) {
        var options = Array.isArray(candidate.options) ? candidate.options : [];
        return options.length === selectedOptions.length && options.every(function (value, index) {
          return String(value) === String(selectedOptions[index]);
        });
      });
      if (!variant) return;

      var form = productInfo.querySelector('form[data-type="add-to-cart-form"]');
      var variantInput = form && form.querySelector('input[name="id"]');
      if (variantInput) variantInput.value = variant.id;
    }

    removePortaledDrawers() {
      document.querySelectorAll('product-drawer[id*="fab-quick-add"]').forEach(function (drawer) {
        drawer.remove();
      });
    }

    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }

    show(opener) {
      this.openedBy = opener || null;
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      this.setAttribute('aria-busy', 'true');
      if (typeof trapFocus === 'function') trapFocus(this, this.dialog);
    }

    hide(preventFocus) {
      if (this.abortController) this.abortController.abort();
      this.abortController = null;
      this.removeAttribute('open');
      this.removeAttribute('aria-busy');
      this.removePortaledDrawers();
      if (this.content) this.content.innerHTML = '';
      this.setStatus('');
      if (!document.querySelector('cart-drawer.active')) {
        document.body.classList.remove('overflow-hidden');
      }
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      if (!preventFocus && typeof removeTrapFocus === 'function') {
        removeTrapFocus(this.openedBy);
      }
      this.openedBy = null;
    }

    setStatus(message, kind) {
      if (!this.status) return;
      if (!message) {
        this.status.hidden = true;
        this.status.textContent = '';
        this.status.removeAttribute('data-kind');
        return;
      }
      this.status.hidden = false;
      this.status.dataset.kind = kind || 'loading';
      this.status.textContent = message;
    }

    openProduct(url, opener) {
      this.requestId += 1;
      var current = this.requestId;
      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();
      this.removePortaledDrawers();
      if (this.content) this.content.innerHTML = '';
      this.setStatus('Loading…', 'loading');
      this.show(opener);

      Promise.all([
        loadQuickAddDeps(),
        fetchProductHtml(url, this.abortController.signal),
      ])
        .then(function (results) {
          var text = results[1];
          if (current !== this.requestId) return;
          if (!text) return;
          var html = new DOMParser().parseFromString(text, 'text/html');
          var productInfo = html.querySelector('product-info');
          if (!productInfo) throw new Error('quick-add missing product-info');
          productInfo.setAttribute('data-update-url', 'false');
          productInfo.setAttribute('data-original-section', SECTION_ID);
          this.setStatus('');
          setInnerHTML(this.content, productInfo.outerHTML);
          var liveProductInfo = this.content.querySelector('product-info');
          if (liveProductInfo) {
            liveProductInfo.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
          }
          this.removeAttribute('aria-busy');
          if (window.__fabTrackingHelpers && typeof window.__fabTrackingHelpers.notifyInjected === 'function') {
            window.__fabTrackingHelpers.notifyInjected(this.content);
          }
          var title = this.content.querySelector('.product__title h2, .product__title h1');
          if (title) {
            if (!title.id) title.id = 'FabQuickAddTitleLive';
            this.dialog.setAttribute('aria-labelledby', title.id);
          }
          if (typeof trapFocus === 'function') {
            trapFocus(this, this.querySelector('[id^="ModalClose-"]') || this.dialog);
          }
        }.bind(this))
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          if (current !== this.requestId) return;
          this.removeAttribute('aria-busy');
          this.setStatus('Couldn’t load this piece.', 'error');
        }.bind(this));
    }
  }

  customElements.define('fab-quick-add-modal', FabQuickAddModal);

  function hostFromEvent(event) {
    var target = event.target;
    if (!target || !target.closest) return null;
    return target.closest('[data-fab-hww-buybox]');
  }

  function trackQuickAdd(trigger) {
    var helpers = window.__fabTrackingHelpers;
    if (!helpers || typeof helpers.capture !== 'function') return;
    var position = Number.parseInt(trigger.getAttribute('data-position') || '', 10);
    var listId = typeof helpers.getListInstanceIdForEl === 'function'
      ? helpers.getListInstanceIdForEl(trigger)
      : null;
    var context = typeof helpers.buildMergedContext === 'function'
      ? helpers.buildMergedContext(trigger)
      : {};
    helpers.capture('clicked', Object.assign({
      target_type: 'quick_add',
      target_id: trigger.getAttribute('data-target-id') || trigger.getAttribute('data-product-id') || null,
      slot: Number.isFinite(position) ? position : null,
      position: Number.isFinite(position) ? position : null,
      is_seed: trigger.getAttribute('data-is-seed') === 'true',
      list_instance_id: listId,
      href: trigger.getAttribute('data-fab-quick-add-url') || null
    }, context));
  }

  function onClick(event) {
    if (isModifiedClick(event)) return;
    var trigger = event.target.closest && event.target.closest('[data-fab-quick-add-trigger]');
    if (trigger) {
      var productUrl = trigger.getAttribute('data-fab-quick-add-url') || '';
      if (productUrl.indexOf('/products/') === -1) return;
      trackQuickAdd(trigger);
      event.preventDefault();
      event.stopPropagation();
      var cardModal = document.querySelector('fab-quick-add-modal');
      if (!cardModal || typeof cardModal.openProduct !== 'function') {
        window.location.href = productUrl;
        return;
      }
      cardModal.openProduct(productUrl, trigger);
      return;
    }

    var host = hostFromEvent(event);
    if (!host) return;
    if (event.target.closest('[data-fab-quick-add-details]')) return;
    var link = event.target.closest('a[href]');
    if (!link || !host.contains(link)) {
      var item = event.target.closest('.fab-hww-buybox__item, .product-card');
      link = item && host.contains(item) ? item.querySelector('a[href*="/products/"]') : null;
    }
    if (!link || !host.contains(link)) return;
    var href = link.getAttribute('href') || '';
    if (href.indexOf('/products/') === -1) return;
    event.preventDefault();
    event.stopPropagation();
    var modal = document.querySelector('fab-quick-add-modal');
    if (!modal || typeof modal.openProduct !== 'function') {
      window.location.href = link.href;
      return;
    }
    modal.openProduct(link.href, link);
  }

  document.addEventListener('click', onClick, true);
  window.FabQuickAdd = { preloadDeps: loadQuickAddDeps };
})();
